(() => {
  const TRIGGER_PRODUCT_HANDLE = "smartcard-location-tracker";
  const TRIGGER_QUANTITY       = 4;
  const GIFT_PRODUCT_HANDLE    = "magsafe-wireless-charger";

  let triggerVariantId = null;
  let giftVariantId    = null;

  // ——— dispatch theme-refresh events ———
  const dispatchRefresh = () => {
    // document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  // ——— Shopify AJAX helpers ———
  const getVariantIdFromHandle = async (handle) => {
    const res     = await fetch(`/products/${handle}.js`);
    const product = await res.json();
    return product.variants[0].id;
  };
  const getCart = async () => {
    const res = await fetch("/cart.js");
    return res.json();
  };

  // ——— adjust gift count to match floor(triggerQty/4) ———
  const setGiftCount = async (n, cart) => {
    const giftLine = cart.items.find(item =>
      item.id === giftVariantId &&
      item.properties?._isFreeGift
    );

    if (giftLine) {
      const line = cart.items.findIndex(i => i.key === giftLine.key) + 1;
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line, quantity: n })
      });
    } else if (n > 0) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id:        giftVariantId,
          quantity:  n,
          properties:{ _isFreeGift: true }
        })
      });
    }

    dispatchRefresh();
  };

  // ——— core sync logic ———
  const syncFreeGift = async () => {
    const cart = await getCart();
    const triggerLine = cart.items.find(i => i.id === triggerVariantId);
    const triggerQty  = triggerLine ? triggerLine.quantity : 0;
    const neededGifts = Math.floor(triggerQty / TRIGGER_QUANTITY);

    const existingGiftLine = cart.items.find(i =>
      i.id === giftVariantId &&
      i.properties?._isFreeGift
    );
    const currentGifts = existingGiftLine ? existingGiftLine.quantity : 0;

    if (currentGifts !== neededGifts) {
      await setGiftCount(neededGifts, cart);
    }
  };

  // ——— bootstrap ———
  const init = async () => {
    triggerVariantId = await getVariantIdFromHandle(TRIGGER_PRODUCT_HANDLE);
    giftVariantId    = await getVariantIdFromHandle(GIFT_PRODUCT_HANDLE);

    // initial sync
    await syncFreeGift();

    // 1) listen for your theme’s cart events
    document.addEventListener('cart:updated',    syncFreeGift);
    document.addEventListener('cart:refresh',    syncFreeGift);
    document.addEventListener('cart:line:added', syncFreeGift);
    document.addEventListener('cart:line:removed', syncFreeGift);

    // 2) patch fetch to catch any AJAX adds/changes
    const realFetch = window.fetch;
    window.fetch = async (...args) => {
      const url = args[0]?.toString();
      const res = await realFetch.apply(this, args);
      if (url.includes("/cart/add.js") || url.includes("/cart/change.js")) {
        setTimeout(syncFreeGift, 200);
      }
      return res;
    };
  };

  document.addEventListener("DOMContentLoaded", init);
})();
